import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class SearchBox extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    initialValue: PropTypes.string,
    onQueryChange: PropTypes.func,
    onSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    initialValue: '',
    onQueryChange: () => {},
    onSubmit: () => {},
    placeholder: t('Search'),
    style: {},
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.state = {
      value: props.initialValue || '',
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.props.onQueryChange(this.state.value);
    }
  }

  render() {
    return (
      <div
        className={`SearchBox ${this.props.className}`}
        style={this.props.style}>
        <span className={'SearchBox-icon-wrapper'}>
          <SvgSymbol name={'search'} />
        </span>
        <input
          onChange={this.handleChange}
          onKeyPress={this.onKeyPress}
          placeholder={this.props.placeholder}
          type={'text'}
          value={this.state.value}
        />
      </div>
    );
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
    });
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.props.onSubmit(this.state.value);
    }
  }
}
